import React, { Suspense, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { $api } from '@/queryClient';
import MainLayout from '@/layouts/MainLayout';
import Loading from '@/components/Loading';
import ModalWelcome from '@/components/ModalWelcome';
import { useStore } from './store';
import { convertDateForIos } from '@/lib';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Asia/Ho_Chi_Minh")

const Home = React.lazy(() => import('@/pages/Home'));

const App = () => {
	const { updateState } = useStore();

	const { data: _userData, status: statusSettings } = $api.useQuery('get', '/api/user/get', {});

	const [showWelcome, setShowWelcome] = React.useState(false);

	useEffect(() => {
		if (statusSettings == 'success' || statusSettings == 'error') {
			updateState('userLoaded', true);
			const delta = new Date(convertDateForIos(_userData?.payload?.current_datetime ?? '')).getTime() - new Date().getTime();
			updateState('delta', delta)

			// Show welcome modal if user is new and we haven't shown it yet
			if (_userData?.payload?.user?.user_type === 'new' && !sessionStorage.getItem('welcomeShown')) {
				setShowWelcome(true);
				sessionStorage.setItem('welcomeShown', 'true');
			}
		}
	}, [statusSettings || '']);

	return (
		<BrowserRouter basename="/">
			<Suspense fallback={<Loading />}>
				<MainLayout>
					<Routes>
						<Route path="/" element={<Home />}></Route>
						<Route
							path="*"
							element={
								<>
									<div className="text-center">Oops! Not found!</div>
								</>
							}
						></Route>
					</Routes>
					<ModalWelcome modalStatus={showWelcome} closeModal={() => setShowWelcome(false)} />
				</MainLayout>
			</Suspense>
		</BrowserRouter>
	);
};

export default App;
